window.enableContactUsSubmitButton = function () {
  $('#new_contact_form input[type="submit"]')[0].disabled = false;
};
